module.exports = __webpack_public_path__ + "img/product_25.3252f32.webp";